export enum ReviewScoreType {
    LOW = 'low',
    MEDIUM = 'medium',
    HIGH = 'high'
}
